var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 480,
    height: 489,
    viewBox: "0 0 480 489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7531",
    "data-name": "Rectangle 7531",
    width: 182.514,
    height: 259.846,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-fitMini"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 489
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fitMini",
    clipPath: "url(#clip-fitMini)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17639",
    "data-name": "Group 17639",
    transform: "translate(149 115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7530",
    "data-name": "Rectangle 7530",
    width: 94.689,
    height: 18.476,
    transform: "translate(44.613 198.887)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17638",
    "data-name": "Group 17638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17637",
    "data-name": "Group 17637",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57661",
    "data-name": "Path 57661",
    d: "M12.787,410.086v18.476H3.33a2.733,2.733,0,0,1-2.737-2.726V412.811a2.733,2.733,0,0,1,2.737-2.725Z",
    transform: "translate(-0.305 -211.199)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57662",
    "data-name": "Path 57662",
    d: "M76.519,325.631v97.16a2.952,2.952,0,0,1-2.708,3.141H65.777a2.959,2.959,0,0,1-2.708-3.141v-97.16a2.966,2.966,0,0,1,2.708-3.141h8.034a2.959,2.959,0,0,1,2.708,3.141",
    transform: "translate(-32.481 -166.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57663",
    "data-name": "Path 57663",
    d: "M81.3,325.631v97.16a2.927,2.927,0,0,1-2.642,3.141H70.823a2.934,2.934,0,0,1-2.642-3.141v-97.16a2.941,2.941,0,0,1,2.642-3.141h7.838a2.934,2.934,0,0,1,2.642,3.141",
    transform: "translate(-35.114 -166.086)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57664",
    "data-name": "Path 57664",
    d: "M52.131,349.514v77.229H44.545a2.718,2.718,0,0,1-2.714-2.714v-71.8a2.725,2.725,0,0,1,2.714-2.714Z",
    transform: "translate(-21.543 -180.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57665",
    "data-name": "Path 57665",
    d: "M54.546,349.514v77.229H48.635a2.474,2.474,0,0,1-2.115-2.714v-71.8a2.482,2.482,0,0,1,2.115-2.714Z",
    transform: "translate(-23.958 -180.004)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57666",
    "data-name": "Path 57666",
    d: "M33.542,378.395V427.61H27.907a2.173,2.173,0,0,1-2.171-2.16V380.566a2.175,2.175,0,0,1,2.171-2.171Z",
    transform: "translate(-13.254 -194.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57667",
    "data-name": "Path 57667",
    d: "M35.763,378.395V427.61H31.64c-.871,0-1.589-.97-1.589-2.16V380.566c0-1.2.718-2.171,1.589-2.171Z",
    transform: "translate(-15.477 -194.878)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57668",
    "data-name": "Path 57668",
    d: "M350.591,410.086v18.476h9.457a2.733,2.733,0,0,0,2.737-2.726V412.811a2.733,2.733,0,0,0-2.737-2.725Z",
    transform: "translate(-180.558 -211.199)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57669",
    "data-name": "Path 57669",
    d: "M284.967,325.631v97.16a2.973,2.973,0,0,0,2.763,3.141h8.195a2.98,2.98,0,0,0,2.763-3.141v-97.16a2.988,2.988,0,0,0-2.763-3.141H287.73a2.98,2.98,0,0,0-2.763,3.141",
    transform: "translate(-146.761 -166.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57670",
    "data-name": "Path 57670",
    d: "M281.091,325.631v97.16a2.927,2.927,0,0,0,2.642,3.141h7.838a2.934,2.934,0,0,0,2.642-3.141v-97.16a2.941,2.941,0,0,0-2.642-3.141h-7.838a2.934,2.934,0,0,0-2.642,3.141",
    transform: "translate(-144.765 -166.086)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57671",
    "data-name": "Path 57671",
    d: "M313.257,349.514v77.229h7.587a2.718,2.718,0,0,0,2.714-2.714v-71.8a2.725,2.725,0,0,0-2.714-2.714Z",
    transform: "translate(-161.331 -180.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57672",
    "data-name": "Path 57672",
    d: "M313.257,349.514v77.229h5.912a2.474,2.474,0,0,0,2.115-2.714v-71.8a2.482,2.482,0,0,0-2.115-2.714Z",
    transform: "translate(-161.331 -180.004)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57673",
    "data-name": "Path 57673",
    d: "M334.5,378.395V427.61h5.635a2.173,2.173,0,0,0,2.171-2.16V380.566a2.175,2.175,0,0,0-2.171-2.171Z",
    transform: "translate(-172.269 -194.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57674",
    "data-name": "Path 57674",
    d: "M334.5,378.395V427.61h4.115c.869,0,1.585-.97,1.585-2.16V380.566c0-1.2-.716-2.171-1.585-2.171Z",
    transform: "translate(-172.271 -194.878)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57675",
    "data-name": "Path 57675",
    d: "M325.769,81.46v71.366c0,4.434-.873,10.683-2.529,11.873s-8.074,2.926-21.276,2.926-19.61-1.745-21.276-2.926-2.529-7.439-2.529-11.873V81.46s.317-2.242,3.025-6.646,4.146-8.59-1.349-11.684a2.542,2.542,0,0,1-1.478-2.4c-.04-1.855-.516-4.93,1.974-6.537a126.864,126.864,0,0,1,21.633-2.123A126.872,126.872,0,0,1,323.6,54.193c2.489,1.607,2.014,4.682,1.984,6.537a2.557,2.557,0,0,1-1.478,2.4c-5.505,3.095-4.057,7.29-1.349,11.684s3.015,6.646,3.015,6.646",
    transform: "translate(-143.255 -26.817)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57676",
    "data-name": "Path 57676",
    d: "M325.8,26.166c.03,1.022-1.6,1.21-1.6,1.21a126.873,126.873,0,0,0-21.633-2.123,126.869,126.869,0,0,0-21.632,2.123s-1.627-.188-1.6-1.21,1.141-11.655,1.141-11.655,2.122-4.017,14.719-5.435c0,0,1.19-.08.952-7.013h-2.113S294.163,0,302.574,0s8.669,2.063,8.669,2.063h-2.252c-.227,6.933.953,7.013.953,7.013,12.6,1.418,14.729,5.435,14.729,5.435s1.1,10.633,1.131,11.655",
    transform: "translate(-143.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57677",
    "data-name": "Path 57677",
    d: "M99.405,166.66a41.446,41.446,0,0,1-8.124,24.718s-12.448,5.108-33.566,5.108-33.555-5.108-33.555-5.108a41.663,41.663,0,0,1,.456-50.041,40.4,40.4,0,0,1,5.227-5.664A41.686,41.686,0,0,1,99.405,166.66",
    transform: "translate(-8.259 -64.367)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57678",
    "data-name": "Path 57678",
    d: "M85.7,103.294c-1.567-2.053-6.447-8.659-8.362-10.385,0,0,38.059-40.161-27.872-40.161S21.585,92.909,21.585,92.909a94.137,94.137,0,0,0-7.982,8.648S-34.218,41.946,49.467,41.946,85.7,103.294,85.7,103.294",
    transform: "translate(0 -21.603)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitMini);
export default __webpack_public_path__ + "static/media/fitMini.b0240c29fa0ca17f83eed635a9b66d38.svg";
export { ForwardRef as ReactComponent };